<template>
  <div class="normal">
    <div class="title">{{ tipMessage }}</div>
    <div class="remark">
      <div class="label">加急原因</div>
      <a-textarea
        :value="urgeReason"
        @input="onInput"
        :auto-size="{ minRows: 3, maxRows: 5 }"
        placeholder="填写原因，此部分内容会通知到药房"
        :maxlength="200"
        show-count
      />
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'
const props = defineProps({
  detail: { type: Object, default: () => ({}) },
  urgeReason: { type: String, default: '' }
})
const emit = defineEmits(['update:urgeReason'])
const tipMessage = computed(() => props.detail.tipMessage)
const onInput = e => {
  emit('update:urgeReason', e.target.value)
}
</script>

<style lang="scss" scoped>
.normal {
  .title {
    margin: 14px 0;
  }
  .remark {
    .label {
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      margin-bottom: 8px;
    }
  }
}
</style>
